module.exports = __webpack_public_path__ + "images/kihnu/ms-icon-310x310.png";